import React from "react";
import ReactDOM from "react-dom/client";
import "./theme.css";
import "./index.css";
import "./shoptet-legacy.css";
import "./i18n";
import Admin from "./Admin";
import App from "./App";
import { AppSettingsProvider } from "./providers/appSettingsProvider";
import { listenToAdminTheme } from "./utils/adminTheme";
import "iframe-resizer/js/iframeResizer.contentWindow";
// eslint-disable-next-line import/no-unresolved -- subpath from the package's exports map, which the import resolver does not read
import "@shoptet/ui/index.css";

listenToAdminTheme();

const rootElement = document.getElementById("shoptet-root") as HTMLElement;

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AppSettingsProvider>{window.location.pathname.startsWith("/admin") ? <Admin /> : <App />}</AppSettingsProvider>
  </React.StrictMode>
);
